module.exports = __webpack_public_path__ + "html/subscription-current-plan_2915a0ccf112a686992d710afc3f1118.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-current-plan.html
// module id = dYBL
// module chunks = 56